<template>
  <div class="SX">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoPartyDiscipline">党纪法规></span>
        <span @click="GoFenLei">分类系统></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
      <div class="zhengwen">
        <h1>全国人大常委会２０１５年立法工作计划（２０１５年修正）</h1>
        <div class="first">
          <p>（２０１４年１２月１５日第十二届全国人民代表大会常务委员会第三十六次委员长会议原则通过 ２０１５年４月１０日第十二届全国人民代表大会常务委员会第四十五次委员长会议修改）</p>
        </div>
        <div class="date">发布时间：2020-5-20&nbsp13:30</div>
       <div class="xh"></div>

        <div class="second">
          <p>全国人大常委会2015年立法工作的总体要求是，全面贯彻落实党的十八大和十八届三中、四中全会精神，高举中国特色社会主义伟大旗帜，以邓小平理论、“三个代表”重要思想、科学发展观为指导，深入学习贯彻习近平总书记系列重要讲话精神，紧紧围绕全面建成小康社会、全面深化改革、全面依法治国、全面从严治党的战略布局，贯彻中国特色社会主义法治理论，主动适应改革和经济发展需要，发挥立法的引领和推动作用，加强重点领域立法，注重各方面法律制度的协调发展，深入推进科学立法、民主立法，拓宽、创新公民有序参与立法的途径和形式，着力提高立法质量，完善以宪法为核心的中国特色社会主义法律体系，推进中国特色社会主义法治体系建设，为实现“两个一百年”奋斗目标、实现中华民族伟大复兴的中国梦作出新贡献。</p>
          <p>一、加强重点领域立法，做好相关法律案审议工作</p>

          <p>按照完善以宪法为核心的中国特色社会主义法律体系的要求，根据五年立法规划和常委会2015年工作要点的安排，突出重点，对2015年法律案审议工作作如下安排：</p>

          <p>（一）继续审议的法律案</p>

          <p>1 反恐怖主义法（2月）</p>

          <p>2 立法法（修改）（已通过）</p>

          <p>3 广告法（修改）（4月）</p>
          <p>4 国家安全法（4月）</p>

          <p>5 食品安全法（修改）（4月）</p>

          <p>6 境外非政府组织管理法（4月）</p>

          <p>7 刑法修正案（九）（6月）</p>

          <p>8 大气污染防治法（修改）（6月）</p>

          <p>9 资产评估法（8月）</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    GoPartyDiscipline() {
      this.$router.push("/PartyDiscipline");
    },
    GoFenLei() {
      this.$router.push("/PartyDiscipline/FenLei");
    }
  }
};
</script>
<style lang="less" scoped>
.date {
  color: #999999;
  font-size: 16px;
  text-align: center;
  margin-bottom: 28px;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}

h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.first p {
  font-weight: 600;
}
</style>